import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index/index'),

  },
    {
    path: '/test',
    name: 'test',
    component: () => import('@/pages/test/index'),

  },
]
})
//解决"当前路由"跳转"当前路由"报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js